module.exports = __webpack_public_path__ + "img/arrow-left-2-w.e213976d.svg";